<template>
  <b-row>
    <b-col cols="7">
      <strong>{{ name }}</strong>
      <span v-if="member.operand"> [{{ member.operand }}]</span>
      <span v-if="member.operator">&nbsp;{{ member.operator }}&nbsp;</span>
    </b-col>
    <b-col cols="5" class="d-flex justify-content-end align-items-center">
      <template v-if="varItem.type === 'BOOL'">
        <b-select
          :disabled="member.readonly"
          :options="boolOptions"
          :value="value"
          lazy
          @change="setMembersValue"
        />
      </template>
      <template v-else>
        <b-input
          type="number"
          :value="value"
          :disabled="member.readonly"
          lazy
          @change="setMembersValue"
        />
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from 'axios';
import ToasterMixin from '@/mixins/Toaster';
import config from '@/config';
import { castOutVariable, castInVariable } from '@/utils/variables';


export default {
  name: 'member',
  props: ['member', 'vars', 'operator'],
  mixins: [ToasterMixin],
  data() {
    return {
      value: null,
      boolOptions: [
        { value: true, text: this.$t('turned-on') },
        { value: false, text: this.$t('turned-off') },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getActorById',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    varItem() {
      return this.getVarByLink(this.member.identifier);
    },
    actor() {
      return this.getActorById(this.varItem.actorId);
    },
    name() {
      if (this.currentSnapshot.rev === 2) {
        if (this.actor.control_group === 'settings') {
          return this.varItem.title;
        }
        return this.actor.title;
      }
      if (this.actor.control_group === 'settings') {
        return this.varItem.description;
      }
      return this.actor.name;
    },
  },
  methods: {
    getVarByLink(link) {
      return this.vars[link];
    },
    async setMembersValue(value) {
      this.value = value;
      try {
        await axios.patch(
          this.$backendUrl(
            config.ICOOL.API.USER_NOTIFICATION_MEMBER_PATH(this.currentSnapshot.id, this.member.id),
          ),
          { value: castOutVariable(value, this.varItem.type) },
        );
        this.showToast(this.$t('notification-settings'), this.$t('set'), 'success');
      } catch (err) {
        console.log(err);
        this.value = castInVariable(this.member.value);
        this.showToast(this.$t('notification-settings'), this.$t('error'), 'danger');
      }
    },
  },
  mounted() {
    this.value = castInVariable(this.member.value, this.varItem.type);
  },
};
</script>

<style scoped>

</style>
